module.exports = __webpack_public_path__ + "static/img/logo1.d2123fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo1.svg
// module id = 4FYo
// module chunks = 110